import { EllipsisVerticalIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ReactNode } from "react";
import { Button } from "@/core/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/core/components/ui/dropdown-menu";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

interface DropdownAction {
  label: string;
  onClick: () => void;
  variant?: "default" | "destructive";
}

interface BusinessSettingsSidebarHeaderProps extends React.PropsWithChildren {
  headerText?: string;
  name: string | null;
  onClose: () => void;
  actions?: ReactNode;
  dropdownActions?: DropdownAction[];
  className?: string;
}

export const BusinessSettingsSidebarHeader = ({
  headerText,
  name,
  onClose,
  actions,
  dropdownActions,
  className = "",
  children,
}: BusinessSettingsSidebarHeaderProps) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    className={cn("flex-none bg-bg-secondary/50 p-6", className)}
  >
    <Stack gap={children ? "md" : "xs"}>
      {children}
      {headerText && <Typography variant="captionW1">{headerText}</Typography>}
      <Typography variant="subtitleW1">{name ?? ""}</Typography>
    </Stack>
    <Stack direction="row" align="center" gap="sm">
      {actions}
      {dropdownActions && dropdownActions.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm" className="h-6 w-6 p-0">
              <EllipsisVerticalIcon className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {dropdownActions.map((action, index) => (
              <DropdownMenuItem
                key={index}
                onClick={action.onClick}
                className={
                  action.variant === "destructive"
                    ? "text-red-600 focus:text-red-600"
                    : ""
                }
              >
                {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      <XMarkIcon className="h-6 w-6 cursor-pointer" onClick={onClose} />
    </Stack>
  </Stack>
);
